import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import BookingPayment from "../components/finance/BookingPayment";
import InvoiceSection from "../components/finance/Invoice";
import PaymentConfirmations from "../components/finance/PaymentConfirmation";
import PaymentTaxDetails from "../components/finance/PaymentTaxDetail";
import { useTransaction } from "../hooks/useTransactions";

const FinancePage = () => {
  const [selectedSection, setSelectedSection] =
    useState<string>("BookingPayment");
  const [transactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getTransactions } = useTransaction();

  const sectionSelected = (selected: string) => {
    setSelectedSection(selected);
  };
  useEffect(() => {
    const getTransactionData = async () => {
      setLoading(true);
      const response = await getTransactions();
      setLoading(false);
      setTransactionData(response.transactions);
      console.log("gettransa", response);
    };

    getTransactionData();
  }, []);

  console.log("transaction", transactionData);
  return (
    <div>
      <Navbar />
      <div className="max-w-7xl mx-auto my-6">
        <h1 className="text-2xl font-semibold mt-10 mb-6">Finance</h1>
        <div className="p-4 lg:p-8 bg-gray-50 min-h-screen">
          <div className="flex border-b overflow-x-auto">
            <button
              className={`px-4 py-2 font-medium flex-shrink-0 hover:text-blue-600 ${
                selectedSection === "BookingPayment"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => sectionSelected("BookingPayment")}
            >
              Bookings for payout
            </button>
            <button
              className={`px-4 py-2 font-medium flex-shrink-0 hover:text-blue-600 ${
                selectedSection === "invoice"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => sectionSelected("invoice")}
            >
              Invoices
            </button>
            <button
              className={`px-4 py-2 font-medium flex-shrink-0 hover:text-blue-600 ${
                selectedSection === "paymentConfirmation"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => sectionSelected("paymentConfirmation")}
            >
              Payment Confirmations
            </button>
            <button
              className={`px-4 py-2 font-medium flex-shrink-0 hover:text-blue-600 ${
                selectedSection === "paymentTaxDetail"
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-600"
              }`}
              onClick={() => sectionSelected("paymentTaxDetail")}
            >
              Payment & tax details
            </button>
          </div>

          <div>
            {selectedSection === "BookingPayment" && (
              <BookingPayment transaction={transactionData} loading={loading} />
            )}

            {selectedSection === "invoice" && (
              <InvoiceSection transaction={transactionData} loading={loading} />
            )}

            {selectedSection === "paymentConfirmation" && (
              <PaymentConfirmations
                transaction={transactionData}
                loading={loading}
              />
            )}

            {selectedSection === "paymentTaxDetail" && (
              <PaymentTaxDetails
                transaction={transactionData}
                loading={loading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancePage;
